import React from 'react';
import {Route, Switch} from 'react-router-dom';

import Dashboard from './dashboard/';
import Edit from './edit/';

class AutomaticMessages extends React.Component {
  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.path}/edit/:id`} component={Edit}/>
        <Route path={`${this.props.match.path}/new`} component={Edit}/>
        <Route path={`${this.props.match.path}`} component={Dashboard}/>
      </Switch>
    )
  }
}

module.exports = AutomaticMessages;



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/automatic-messages/index.js